export enum PromoEvent {
  PromoClick = 'select_promotion',
  PromoView = 'view_promotion',
  PromoClose = 'close_promotion',
}

export enum VideoEvent {
  VideoStart = 'video_start',
  VideoComplete = 'video_complete',
}

export enum CommonBannerEvent {
  View = 'common-banner_view',
  Click = 'common-banner_click',
}

export enum MediaType {
  Image = 'image',
  Video = 'video',
}

export const enum ProductEvent {
  View = 'view_item_list',
  ViewClick = 'product-list-view_click',
  Click = 'select_item',
  DetailView = 'view_item',
  InlineQuickViewClick = 'inline-quickview_click',
}

export enum EventAction {
  Click = 'click',
  Close = 'close',
  View = 'view',
  Success = 'success',
  Login = 'login',
  Signup = 'signup',
  Error = 'error',
}

export enum EventCategory {
  Product = 'product',
  Promotion = 'promotion',
  User = 'user',
  Link = 'link',
  Newsletter = 'newsletter',
}

export enum CartEvent {
  AddToCart = 'add_to_cart',
  RemoveFromCart = 'remove_from_cart',
}

export enum NewsletterSignupEvent {
  NewsLetterSignUpClick = 'newsletter_sign_up_click',
  NewsLetterSignUpSuccess = 'newsletter_sign_up_success',
}

export enum NewsletterSignupName {
  NewsletterOverlay = 'NewsletterOverlay',
  NewsletterSignUp = 'NewsletterSignUp',
  NewsletterPopUpFullScreen = 'NewsletterPopUpFullScreen',
  NewsletterPopUpMinimized = 'NewsletterPopUpMinimized',
  NewsletterSubscriptionCheckBox = 'NewsletterSubscriptionCheckBox',
}

export enum WishlistButtonEvent {
  RemoveFromWishlist = 'remove_from_wishlist',
  AddToWishlist = 'add_to_wishlist',
}

export const enum MyAccountEvent {
  OverviewClick = 'my-account-overview_click',
  SubscriptionClick = 'subscriptions-list_click',
  ProfileUpdate = 'my_account_profile',
}

export enum ErrorEvent {
  ErrorView = 'error_view',
}

export enum ErrorEventMessage {
  NotSellable = 'not sellable',
  GenericMessage = 'generic message',
}

export const enum DrawerType {
  Rating = 'rating',
  ZipCodeGlobalHeader = 'zip code - global header',
  ZipCodeCartSummary = 'zip code - cart summary',
}

export const enum AddToCartPlacement {
  AccessorySlider = 'PDP - Accessories',
  InlineQV = 'InlineQV',
  ProductComparisonTable = 'Product Comparison',
  Wishlist = 'Wishlist - Wishlist grid',
}

export const enum ProductComparisonEvent {
  ToggleView = 'product-comparison-toggle_view',
  ToggleClick = 'product-comparison-toggle_click',
  TableClick = 'product-comparison-table_click',
}
